﻿import React from 'react';
import { EpiContext } from '../../Shared/Scripts/Store/EpiContext/Types';
import VeilederBsDto from '../Models/VeilederBsDto';
import { connect } from 'react-redux';
import { VeilederBsAppState } from '../Store';
import { toggleVilkar } from '../Store/Valg/Actions';
import { BoksResultat } from '../Ids';
import { ModalCompontent } from '../../Shared/Scripts/Components/ModalComponent';
import { updateZIndex } from '../../Shared/Scripts/Store/EpiContext/Actions';
import { ArticleContentComponent } from '../../Shared/Scripts/Components/ArticleContentComponent';
import { updateLiveMessage } from '../../Shared/Scripts/Utilities/LiveMessage';

interface ResultOwnProps {
    tittel: JSX.Element | null;
    sekundartittel: JSX.Element | null;
    info: JSX.Element | null;
    lenketekst: JSX.Element | null;
    overskriftModal: JSX.Element | null;
    contentModal: JSX.Element | null;
    ariaLabelModal: string;
    eventId: string | null;
}

type ResultatProps = MapStateToProps & MapDispatchToProps & ResultOwnProps;

class ResultatComponent extends React.PureComponent<ResultatProps> {
    constructor(props: ResultatProps) {
        super(props);
        this.onVilkarClick = this.onVilkarClick.bind(this);
        this.onRequestClose = this.onRequestClose.bind(this);
    }

    componentDidMount(): void {
        updateLiveMessage();
    }

    onRequestClose(): void {
        this.props.updateZIndex(1);
        this.props.toggleVilkar();
    }

    onVilkarClick(event: React.MouseEvent): void {
        this.props.updateZIndex(2);
        this.props.toggleVilkar();
    }

    render(): JSX.Element {
        const {
            tittel,
            sekundartittel,
            info,
            lenketekst,
            overskriftModal,
            contentModal,
            ariaLabelModal,
            visVilkar,
            eventId,
        } = this.props;

        return (
            <div
                id={BoksResultat}
                className="c-veileder__panel c-veileder__panel--resultat c-veileder__panel--aubergine"
            >
                <div className="c-veileder__panel-row">
                    <div className="c-veileder__content c-veileder__content--header">
                        <h3 className="c-veileder__tittel c-veileder__tittel--resultat">{tittel}</h3>
                    </div>
                    <div className="c-veileder__content c-veileder__content--with-space c-veileder__content--indented">
                        <h4 className="c-veileder__tittel c-veileder__tittel-sekundar--resultat">{sekundartittel}</h4>
                        <div className="c-veileder__content--textarea">
                            <p>{info}</p>
                        </div>
                    </div>
                </div>
                <div className="c-veileder__panel-row">
                    <div className="c-veileder__content c-veileder__content--footer">
                        <button type="button" className="c-knapp c-knapp--lenke" onClick={this.onVilkarClick}>
                            {lenketekst}
                        </button>
                        <ModalCompontent
                            isOpen={visVilkar}
                            onRequestClose={this.onRequestClose}
                            ariaCloseText={ariaLabelModal}
                            eventId={eventId}
                        >
                            <ArticleContentComponent headerinnhold={overskriftModal} contentinnhold={contentModal} />
                        </ModalCompontent>
                    </div>
                </div>
            </div>
        );
    }
}

interface MapStateToProps {
    epiContext: EpiContext<VeilederBsDto>;
    visVilkar: boolean;
}

interface MapDispatchToProps {
    toggleVilkar: typeof toggleVilkar;
    updateZIndex: typeof updateZIndex;
}

export default connect(
    (state: VeilederBsAppState): MapStateToProps => {
        return {
            epiContext: state.epiContext,
            visVilkar: state.valg.visVilkar,
        };
    },
    { toggleVilkar, updateZIndex },
)(ResultatComponent);
